import { connect } from "react-redux";
import { useEffect, useCallback } from "react";
import toast, { Toaster } from "react-hot-toast";

const ToastContainer = ({ alert }) => {
  const notify = useCallback((alert_type, alert_message) => {
    if (!!alert_type && !!alert_message) {
      // const title = alert_type.charAt(0).toUpperCase() + alert_type.slice(1);
      toast[alert_type](alert_message);
    }
  }, []);

  useEffect(() => {
    if (alert && alert.variant && alert.message) {
      notify(alert.variant, alert.message);
    }
  }, [alert, notify]);

  return (
    <Toaster
      position="top-right"
      reverseOrder={false}
      gutter={8}
      containerClassName=""
      containerStyle={{}}
      toastOptions={{
        // Define default options
        className: "",
        duration: 5000,
        /* style: {
                    background: "#363636",
                    color: "#fff",
                }, */

        // Default options for specific types
        success: {
          duration: 3000,
          theme: {
            primary: "green",
            secondary: "black",
          },
        },
      }}
    />
  );
};

const mapStateToProps = (state) => {
  const { alert } = state;
  return {
    alert,
  };
};

export default connect(mapStateToProps)(ToastContainer);
